/**
 * Modal Lifecycle and Dialog Management Module
 */

let openModalsCount = 0;

/**
 * Opens a modal dialog by element ID and handles scroll reset and backdrop state.
 * @param {string} modalId 
 */
export function openModal(modalId) {
  if (typeof document === 'undefined') return;
  const modal = document.getElementById(modalId);
  if (!modal) return;

  modal.scrollTop = 0;
  const body = modal.querySelector('.modal-body');
  if (body) {
    body.scrollTop = 0;
  }

  if (!modal.classList.contains('open')) {
    modal.classList.add('open');
    openModalsCount++;
    document.body.classList.add('modal-open');
  }
}

/**
 * Closes a modal dialog by element ID.
 * @param {string} modalId 
 * @param {{ force?: boolean, onReset?: () => void }} [options={}]
 */
export function closeModal(modalId, options = {}) {
  if (typeof document === 'undefined') return;
  const modal = document.getElementById(modalId);
  if (!modal) return;

  if (modal.classList.contains('open')) {
    modal.classList.remove('open');
    openModalsCount = Math.max(0, openModalsCount - 1);
    if (openModalsCount === 0) {
      document.body.classList.remove('modal-open');
    }
  }

  if (typeof options.onReset === 'function') {
    options.onReset();
  }
}

// Bind globally to window for legacy inline onclick attributes
if (typeof window !== 'undefined') {
  window.openModal = openModal;
  window.closeModal = closeModal;
}

/**
 * Initializes global click and escape handlers for all modals.
 */
export function initModalEvents() {
  if (typeof document === 'undefined') return;

  // Delegate click events on [data-close-modal] buttons, close icons, and modal backdrops
  document.addEventListener('click', (event) => {
    // 1. Explicit close buttons with data attributes or classes
    const closeBtn = event.target.closest('[data-close-modal], .modal-close, [data-close], .btn-close-modal');
    if (closeBtn) {
      const modalId = closeBtn.getAttribute('data-close-modal') || closeBtn.closest('.modal-overlay')?.id;
      if (modalId) {
        closeModal(modalId);
      }
      return;
    }

    // 2. Header close icon button in modal header (<div class="modal-header"><button class="btn-icon">...)
    const headerCloseBtn = event.target.closest('.modal-header button.btn-icon, .modal-header .btn-icon');
    if (headerCloseBtn) {
      const modal = headerCloseBtn.closest('.modal-overlay');
      if (modal && modal.id) {
        closeModal(modal.id);
        return;
      }
    }

    // 3. Modal footer secondary button with text containing "ปิด" or "ยกเลิก"
    const footerCancelBtn = event.target.closest('.modal-footer .btn-secondary, .modal-body .btn-secondary');
    if (footerCancelBtn && (footerCancelBtn.textContent.includes('ปิด') || footerCancelBtn.textContent.includes('ยกเลิก'))) {
      const modal = footerCancelBtn.closest('.modal-overlay');
      if (modal && modal.id && !footerCancelBtn.closest('form')) {
        closeModal(modal.id);
        return;
      }
    }

    // 4. Modal overlay backdrop click
    if (event.target.classList.contains('modal-overlay')) {
      closeModal(event.target.id);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && openModalsCount > 0) {
      const openModals = document.querySelectorAll('.modal-overlay.open');
      if (openModals.length > 0) {
        const topModal = openModals[openModals.length - 1];
        closeModal(topModal.id);
      }
    }
  });
}
